import { discussionThreads } from "@/mocks/homeData";

export default function DiscussionBoard() {
  return (
    <section id="discussion" className="w-full border-b border-background-200/70 bg-background-50">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4 md:mb-10">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.25em] text-primary-600">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-discuss-line text-sm" />
              </span>
              Board
            </p>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              讨论区热帖
            </h2>
            <p className="mt-2 text-sm text-foreground-500 md:text-base">
              每一条都在继续聊，回复越多，气氛越足。
            </p>
          </div>
          <span className="flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-800 md:text-sm">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-price-tag-3-line text-sm" />
            </span>
            今日新帖 214
          </span>
        </div>

        <ul className="flex flex-col gap-4">
          {discussionThreads.map((th) => (
            <li key={th.id}>
              <a
                href="#comments"
                className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200 hover:bg-background-100 md:flex-row md:items-center md:gap-6"
              >
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    {th.pinned && (
                      <span className="flex items-center gap-1 rounded bg-primary-100 px-2 py-0.5 text-[11px] font-medium text-primary-800">
                        <span className="flex h-3.5 w-3.5 items-center justify-center">
                          <i className="ri-pushpin-2-fill text-xs" />
                        </span>
                        置顶
                      </span>
                    )}
                    <h3 className="text-base font-semibold text-foreground-950 md:text-[17px]">
                      {th.title}
                    </h3>
                  </div>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-500">
                    {th.summary}
                  </p>
                  <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-400">
                    <span className="flex items-center gap-1.5">
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-user-3-line text-sm" />
                      </span>
                      {th.author}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-eye-line text-sm" />
                      </span>
                      {th.views} 围观
                    </span>
                    <span className="flex items-center gap-1.5">
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-history-line text-sm" />
                      </span>
                      {th.lastActive}
                    </span>
                  </div>
                </div>

                <div className="flex shrink-0 items-center gap-4 md:flex-col md:items-end md:gap-1">
                  <span className="flex items-center gap-1.5 text-accent-700">
                    <span className="flex h-5 w-5 items-center justify-center">
                      <i className="ri-chat-3-fill text-base" />
                    </span>
                    <span className="font-heading text-lg font-bold">{th.replies}</span>
                  </span>
                  <span className="text-xs text-foreground-400">条回复</span>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}